<template>
  <svg width="100%" height="100%" id="yAxisLines" ref="yAxisLines">
    <line
      v-for="(value, index) in marginValues"
      :x1 = "getLineX"
      :y1 = "height - (index * yIncrement) - sliderGap"
      :x2 = "getLineX + 20"
      :y2 = "height - (index * yIncrement) - sliderGap"
      stroke-width="1"
      :class = "getLineColor"
    />
    <text
      v-for="(value, index) in marginValues"
      :x = "getTextX"
      :y = "height - (index * yIncrement)  - sliderGap + 4"
      class = "axis-lines-label"
      :class = "getTextClass"
    >
      {{ value }}
    </text>
  </svg>
</template>

<script>
import { useInputStore } from '@/store/InputStore';
import { useSettingsStore } from '@/store/SettingsStore';
import * as UnitConversion from '@/services/UnitConversionService';

export default {
  name: 'YAxisLines',
  props: [
    'side'
  ],
  computed: {
    getLineColor () {
      return this.$props.side === 'left' ? 'pressure-color' : 'flow-color';
    },
    height () {
      return useInputStore().getPressureFlowChartHeight;
    },
    marginValues () {
      const settingsStore = useSettingsStore();
      const isPressure = this.$props.side === 'left';
      let divisions = isPressure ? settingsStore.getPressureYAxisDivision : settingsStore.getFlowYAxisDivision;
      let max = isPressure ? this.filterPressure(this.getCalcData.maxSprinklerPressure) : this.filterEmitterFlow(this.getCalcData.maxNozFlow);
      let min = isPressure ? this.filterPressure(this.getCalcData.minSprinklerPressure) : this.filterEmitterFlow(this.getCalcData.minNozFlow);
      min = settingsStore.getRaiseYAxisOrigin ? settingsStore.prettyChartMin(min) : 0;
      let values = [];
      const chartStep = settingsStore.prettyChartStep(settingsStore.chartStep(max, min, divisions));
      if (min === undefined) { return values; }
      for (let a = 0; a < divisions + 1; a++) {
        let val = chartStep * a;
        val += min;
        values.push((val).toFixed(2));
      }
      return values;
    },
    yIncrement () {
      const inputStore = useInputStore();
      const settingsStore = useSettingsStore();
      let divisions = (this.$props.side === 'left') ? settingsStore.getPressureYAxisDivision : settingsStore.getFlowYAxisDivision;
      return (inputStore.getChartPointsHeight) / divisions;
    },
    sliderGap () {
      return useInputStore().getSliderGap;
    },
    getLineX () {
      return this.$props.side === 'left' ? this.width - 21 : 0;
    },
    getTextX () {
      return this.$props.side === 'left' ? this.width - 25 : 25;
    },
    getTextClass () {
      return this.$props.side === 'left' ? 'yaxis-line-text-left' : 'yaxis-line-text-right';
    },
    getCalcData () {
      return useInputStore().getCalcData;
    },
    width () {
      return useInputStore().getChartAxisLabelWidth;
    },
  },
  methods: {    
    filterPressure (pressure) {
      return (UnitConversion.FilterPressure(pressure, useSettingsStore().getPressureUnit));
    },
    filterEmitterFlow (flow) {
      return (UnitConversion.FilterEmitterFlow(flow, useSettingsStore().getEmitterFlowUnit));
    },
  },
};
</script>

<style scoped>
.axis-lines-label {
  user-select: none;
  font-size: 13px;
  font-weight: 600;
}
.yaxis-line-text-left {
  text-anchor: end;
  fill: var(--pressure-color);
}
.yaxis-line-text-right {
  text-anchor: start;
  fill: var(--flow-color);
}
.pressure-color {
  stroke: var(--pressure-color);
}
.flow-color {
  stroke: var(--flow-color);
}
</style>